import { OrderAccount } from "../../blocks/Account/OrderAccount";
import { Footer } from "../../blocks/Footer/Footer";
import { Help } from "../../blocks/help/help";
import { MenuBottom } from "../../blocks/MenuBottom/MenuBottom";
import { Services } from "../../blocks/sevices/services";
import Header from "../../components/header/header";
import { useLocation } from "react-router";
import { canonicalPath } from "../../utils/canonical";
import { UserProvider } from "../../context/user/UserContext";
import "../../core/core.css";
import { DataProvider } from "../../hooks/DataContext";
import { SupportProvider } from "../../Support/SupportProvider";
import "./../page.css";

const order = () => {
  const currentPage = useLocation();
  return (
    <DataProvider>
      <link
        rel="canonical"
        href={`https://hmrep.ru${canonicalPath(currentPage.pathname)}`}
      />
      <UserProvider>
        <SupportProvider>
          <div className="body">
            <Header></Header>
            <OrderAccount></OrderAccount>
            <div className="blocks">
              <Services></Services>
              <Help></Help>
              <Footer></Footer>
            </div>
            <MenuBottom></MenuBottom>
          </div>
        </SupportProvider>
      </UserProvider>
    </DataProvider>
  );
};

export default order;
